import { CommonModule } from "@angular/common";
import {
	Component,
	OnDestroy,
	OnInit,
	ViewChild,
	ViewEncapsulation,
	computed,
	effect,
	signal,
	viewChild,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { SvgIconComponent } from "angular-svg-icon";
import { MenuItem, MenuItemCommandEvent } from "primeng/api";
import { AvatarModule } from "primeng/avatar";
import { ButtonModule } from "primeng/button";
import { MenuModule } from "primeng/menu";
import { Popover, PopoverModule } from "primeng/popover";
import { ToolbarModule } from "primeng/toolbar";
import { UsersPrivilegeKey } from "../../../core/models/user";
import { EntitledMenuItem } from "../../models/entitledMenuItem";
import { UserDetails } from "../../models/user";
import { AuthService } from "../../services/auth/auth.service";
import { MerchantsService } from "../../services/merchants/merchants.service";
import { SharedService } from "../../services/shared/shared.service";
import { UserService } from "../../services/user/user.service";
import { DialogComponent } from "../dialog/dialog.component";
import { PublisherComponent } from "../publisher/publisher.component";
import { SkeletonModule } from "primeng/skeleton";
import { BadgeModule } from 'primeng/badge';
import { PublisherNotification } from "../../models/common";
import { ManagementService } from "../../services/management.service";
import { Subscription } from "rxjs";
@Component({
    selector: "app-header",
    imports: [
        ToolbarModule,
        AvatarModule,
        ButtonModule,
        CommonModule,
        SvgIconComponent,
        PopoverModule,
        PublisherComponent,
        MenuModule,
        DialogComponent,
        FormsModule,
        SkeletonModule,
        BadgeModule
    ],
    encapsulation: ViewEncapsulation.None,
    templateUrl: "./header.component.html",
    styleUrl: "./header.component.scss"
})
export class HeaderComponent implements OnInit, OnDestroy {
	brandLogo = computed<string>(
	() => {
		if(this.merchantsService.selectedMerchant()){
			return this.merchantsService.selectedMerchant()?.logoUrl || "/assets/images/default-logo.png";
		} else {
			return "";
		}
	});	
	@ViewChild("overlayPanel") overlayPanel!: Popover;
	@ViewChild("publisherContent") publisherContent!: PublisherComponent;
	isOpen$ = this.sharedService.isOpen$;
	signoutConfirmDialog = viewChild<DialogComponent>(DialogComponent);
	userProfileMenuItems: MenuItem[] = [];
	protected userDetails!: UserDetails;
	actionItems: EntitledMenuItem[] | undefined;
	signOut: string = $localize`:@@header.users.sign.out:Sign Out`;
	title: string = $localize`:@@header.users.title:Confirm`;
	content: string = $localize`:@@header.users.content:Are you sure you want to sign out?`;
	unauthorizedAccess = false;
	profile: string = $localize`:@@header.users.profile:Profile`;
	cancelBtn: string = $localize`:@@header.users.cancel:Cancel`;
	notification = signal<boolean>(false);
	intervalId: ReturnType<typeof setTimeout> | number = 0;
	private subscription: Subscription = new Subscription();

	constructor(
		private authService: AuthService,
		private router: Router,
		private userService: UserService,
		private merchantsService: MerchantsService,
		private sharedService: SharedService,
		private managementService: ManagementService
	) {
		effect(() => {
			this.userDetails = userService.loggedInUser()
				? userService.loggedInUser()!
				: ({} as UserDetails);
			this.unauthorizedAccess = this.userService.isAccessNoneAll(
				"mp.publisher",
			);
		});
	}

	ngOnInit() {
		// Handle Publisher Open/Hide based opn the shared services
		this.sharedService.isOpen$.subscribe((isOpen) => {
			if (isOpen) {
				const fakeEvent = {
					currentTarget: null,
					target: null,
				};
				this.overlayPanel.show(fakeEvent);
				this.publisherContent.getPublisherList();
			}
		});
		let visible = true;
		if (this.userDetails?.roles?.length) {
			visible = !this.userService.isAccessNone(UsersPrivilegeKey.Profile);
		}
		this.userProfileMenuItems = [
			{
				label: this.profile,
				routerLinkActiveOptions: { exact: false },
				routerLink: "profile",
				visible: visible,
			},
			{
				label: this.signOut,
				command: (event: MenuItemCommandEvent) => {
					this.showLogoutConfirmDialog();
				},
			},
		];
		this.actionItems = [
			{
				label: "EN",
				command: (event: MenuItemCommandEvent) => {
					localStorage.setItem("locale", "en-US");
					window.location.reload();
				},
			},
			{
				label: "MX",
				command: (event: MenuItemCommandEvent) => {
					localStorage.setItem("locale", "es-MX");
					window.location.reload();
				},
			},
		];
		this.managementService.getPublisherNotification();
		this.intervalId = setInterval(() => {
          this.managementService.getPublisherNotification();
        }, 30000);
		this.subscription = this.managementService.publisherNotification$.subscribe((data) => {
			if(data){
				const details = data.filter(item => item.hasEvents);
				if(details.length){
					this.notification.set(true);
				} else {
					this.notification.set(false);
				}
			}
		});	
	}

	showLogoutConfirmDialog() {
		this.signoutConfirmDialog()?.showDialog();
	}

	logout() {
		this.authService.signOut();
		this.userService.resetUserPrivileges();
		// this.merchantsService.resetSelectedMerchant()
		this.router.navigate(["auth/signin"]);
	}
	openPanel() {
		this.sharedService.openPanel();
	}

	closePanel() {
		this.sharedService.closePanel();
	}

	ngOnDestroy(): void {
		if (this.intervalId) {
          clearInterval(this.intervalId);
        }
	    this.subscription.unsubscribe();	
	}

	updateNotification(status:boolean){
		this.notification.set(status);
	}

	protected readonly UsersPrivilegeKeys = UsersPrivilegeKey;
}
